// extracted by mini-css-extract-plugin
export default {"leaderboard":"leaderboard_leaderboard__HkAe8","wrapper":"leaderboard_wrapper__G4xWt","table":"leaderboard_table__781LL","entry":"leaderboard_entry__ZydQM"};